import { Injectable } from '@angular/core';
import type { IconData } from './icon-data';

const svgNamespace = 'http://www.w3.org/2000/svg';

@Injectable({ providedIn: 'root' })
export class SvgIconRenderer {
  private readonly templates = new WeakMap<IconData, { svg: SVGSVGElement; hasIds: boolean }>();
  private sequence = 0;

  render(data: IconData, host: HTMLElement): void {
    let template = this.templates.get(data);
    if (!template) {
      const document = new DOMParser().parseFromString(data.svg, 'image/svg+xml');
      const svg = document.documentElement as unknown as SVGSVGElement;
      if (document.querySelector('parsererror') || svg.localName !== 'svg' || svg.namespaceURI !== svgNamespace) {
        throw new Error(`Invalid generated SVG: ${data.name}`);
      }
      svg.setAttribute('width', '100%');
      svg.setAttribute('height', '100%');
      svg.setAttribute('focusable', 'false');
      svg.setAttribute('aria-hidden', 'true');
      svg.style.display = 'block';
      svg.style.pointerEvents = 'none';
      template = {
        svg,
        hasIds: svg.hasAttribute('id') || Boolean(svg.querySelector('[id]')),
      };
      this.templates.set(data, template);
    }
    const clone = template.svg.cloneNode(true) as SVGSVGElement;
    if (template.hasIds) this.rewriteIds(clone);
    host.replaceChildren(clone);
  }

  private rewriteIds(svg: SVGSVGElement): void {
    const prefix = `pnkl-${++this.sequence}-`;
    for (const element of [svg, ...svg.querySelectorAll('*')]) {
      for (const attribute of element.attributes) {
        const value = attribute.value;
        if (attribute.name === 'id') attribute.value = `${prefix}${value}`;
        else if (attribute.localName === 'href') attribute.value = `#${prefix}${value.slice(1)}`;
        else if (value.startsWith('url(#')) attribute.value = `url(#${prefix}${value.slice(5, -1)})`;
      }
    }
  }
}
